<template>
  <b-container>
    <b-row>
      <b-col />
      <b-col>
        <b-alert
          :show="dismiss_count_down"
          dismissible
          :variant="variant"
          @dismissed="dismiss_count_down = 0"
          @dismiss-count-down="count_down_changed"
        >
          <p>{{ additional_text }}</p>
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<i18n>
{
  "en": {
    "changes_transmitted": "Your changes have been correctly transmitted to the server"
  },
  "fr": {
    "changes_transmitted": "Vos changements ont bien été transmis au serveur"
  }
}
</i18n>

<script>
export default {
  name: 'SaveConfirmation',
  props: ['optional_text', 'optional_variant'],
  data() {
    return {
      dismiss_secs: 3,
      dismiss_count_down: 0,
    }
  },
  computed: {
    additional_text() {
      let res = this.$t('changes_transmitted')
      if (this.optional_text) {
        res = this.optional_text
      }
      return res
    },
    variant() {
      let res = 'success'
      if (this.optional_variant) {
        res = this.optional_variant
      }
      return res
    },
  },

  methods: {
    count_down_changed(dismiss_count_down) {
      this.dismiss_count_down = dismiss_count_down
    },
    show() {
      this.dismiss_count_down = this.dismiss_secs
    },
  },
}
</script>
